(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const open=event.target.closest('[data-rr-open]');if(open){const modal=document.getElementById(open.dataset.rrOpen);if(modal&&!modal.open)modal.showModal();}if(event.target.matches('dialog.rr-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-launch"] && !Shopify.designMode) return;
  try {
    
function rrUpdatePreferences(form){const tags=['newsletter','roc-rally-launch','brighton'];form.querySelectorAll('[data-rr-interest]:checked').forEach(input=>tags.push('interest:'+input.value));const town=form.querySelector('[data-rr-town]')?.value.trim().toLowerCase().replace(/[^a-z0-9 -]/g,'').replace(/\s+/g,'-').slice(0,60);if(town)tags.push('next-town:'+town);const field=form.querySelector('[data-rr-tags]');if(field)field.value=tags.join(',');}
document.addEventListener('input',event=>{const form=event.target.closest('.rr-launch-form');if(form)rrUpdatePreferences(form);});
document.addEventListener('change',event=>{const form=event.target.closest('.rr-launch-form');if(form)rrUpdatePreferences(form);});
document.addEventListener('submit',event=>{if(event.target.matches('.rr-launch-form'))rrUpdatePreferences(event.target);});

  } catch(e) { console.error(e); }
})();
})();
